//文字コードはutf-8

const initializedDialogs = new WeakSet();
const dialogTriggers = new WeakMap();

function openDialog(dialog, triggerElement) {
  if (triggerElement) {
    dialogTriggers.set(dialog, triggerElement);
  }
  
  // モーダルを開く前に現在のスクロール位置を保存
  const scrollY = window.scrollY || window.pageYOffset;
  
  // モーダルを開く前にスライダーの位置を保存（scrollLockによるレイアウト変更を防ぐため）
  const sliders = document.querySelectorAll('.swiper');
  const sliderPositions = [];
  sliders.forEach((slider) => {
    if (slider._swiperInstance) {
      const swiper = slider._swiperInstance;
      const savedTranslate = swiper.getTranslate();
      sliderPositions.push({
        swiper: swiper,
        translate: savedTranslate
      });
      // モーダルが開いている間、位置を固定するフラグを設定
      swiper._modalOpen = true;
      swiper._modalSavedTranslate = savedTranslate;
    }
  });
  
  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }
  document.body.classList.add('scrollLock');
  
  // アニメーションを開始するために、次のフレームでis-openクラスを追加
  requestAnimationFrame(() => {
    dialog.classList.add('is-open');
  });
  
  // スクロール位置を復元（showModal()でページ上部に戻ってしまうのを防ぐ）
  requestAnimationFrame(() => {
    window.scrollTo(0, scrollY);
  });
  
  // レイアウトが安定するまで待ってからスライダーの位置を復元
  // scrollLockによるレイアウト変更が完了するまで待つ
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      sliderPositions.forEach(({ swiper, translate }) => {
        if (swiper && swiper.el && swiper.el.parentElement) {
          // translate値を直接設定して位置を固定（transitionなし）
          swiper.setTranslate(translate);
        }
      });
    });
  });
  
  // dialogが開いたら最初のフォーカス可能な要素にフォーカス
  const firstFocusable = dialog.querySelector('[data-modal-close], button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (firstFocusable) {
    firstFocusable.focus();
  }
}

function closeDialog(dialog) {
  // アニメーションを開始するために、まずis-openクラスを削除
  dialog.classList.remove('is-open');
  
  // モーダルを閉じる前にスライダーの位置を保存（scrollLock解除によるレイアウト変更を防ぐため）
  const sliders = document.querySelectorAll('.swiper');
  const sliderPositions = [];
  sliders.forEach((slider) => {
    if (slider._swiperInstance) {
      const swiper = slider._swiperInstance;
      // 現在の位置とactiveIndexを保存
      const currentTranslate = swiper.getTranslate();
      const currentActiveIndex = swiper.activeIndex;
      sliderPositions.push({
        swiper: swiper,
        translate: currentTranslate,
        activeIndex: currentActiveIndex
      });
    }
  });
  
  // アニメーション完了後にモーダルを閉じる
  setTimeout(() => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.body.classList.remove('scrollLock');
    
    // レイアウトが安定するまで待ってからスライダーの位置を復元
    // scrollLock解除によるレイアウト変更が完了するまで待つ
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        sliderPositions.forEach(({ swiper, translate, activeIndex }) => {
          if (swiper && swiper.el && swiper.el.parentElement) {
            // 一時的に位置を固定するフラグを設定
            swiper._modalClosing = true;
            swiper._modalClosingTranslate = translate;
            // 位置を設定
            swiper.setTranslate(translate);
          }
        });
        
        // 少し待ってからフラグを解除し、activeIndexを正しく設定
        setTimeout(() => {
          sliderPositions.forEach(({ swiper, activeIndex }) => {
            if (swiper && swiper.el && swiper.el.parentElement) {
              // フラグを解除
              swiper._modalOpen = false;
              swiper._modalClosing = false;
              delete swiper._modalSavedTranslate;
              delete swiper._modalClosingTranslate;
              
              // activeIndexを正しく設定（transitionなし）
              // これにより、ボタンでスクロールしたときに正しい位置から移動する
              swiper.slideTo(activeIndex, 0);
            }
          });
        }, 100);
      });
    });
    
    // 閉じた後、トリガーにフォーカスを戻す
    const triggerElement = dialogTriggers.get(dialog);
    if (triggerElement) {
      triggerElement.focus();
      dialogTriggers.delete(dialog);
    }
  }, 300); // アニメーション時間（0.3s）に合わせる
}

function attachDialogListeners(dialog) {
  if (initializedDialogs.has(dialog)) return;

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      closeDialog(dialog);
    }
  });

  dialog.addEventListener('close', () => {
    document.body.classList.remove('scrollLock');
  });

  dialog.addEventListener('cancel', () => {
    document.body.classList.remove('scrollLock');
  });

  dialog.querySelectorAll('[data-modal-close]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeDialog(dialog);
    });
  });

  initializedDialogs.add(dialog);
}

export function initModal() {
  const triggers = document.querySelectorAll('[data-modal-trigger]');
  if (!triggers.length) return;

  triggers.forEach((trigger) => {
    const targetId = trigger.dataset.modalTrigger;
    if (!targetId) return;

    const dialog = document.getElementById(targetId);
    if (!dialog) return;

    attachDialogListeners(dialog);

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openDialog(dialog, trigger);
    });
  });
}
